import { render, staticRenderFns } from "./RescheduleTicketForm.vue?vue&type=template&id=2a1109b6"
import script from "./RescheduleTicketForm.vue?vue&type=script&lang=js"
export * from "./RescheduleTicketForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports